import React from 'react';
import { observer } from 'mobx-react';
import { getAppRouterState, isSome } from 'core/utils';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import { RouterLink } from 'mobx-state-router';

const MenuTemplate = ({ menuStore, t }) => {
	let apiKey = '';
	observer;
	let {
		rootStore,
		rootStore: { routerStore, viewStore },
	} = menuStore;
	if (rootStore.app) {
		apiKey = rootStore.app.baasic.getApiKey();
	}
	menuStore.syncOpenSubmenu(routerStore.routerState.routeName);
	return (
		<ul className="nav">
			{menuStore.menu.map(item => {
				return renderItem(item, apiKey, routerStore, t, viewStore);
			})}
		</ul>
	);
};

function renderItem(item, apiKey, routerStore, t, viewStore) {
	const hasChildren = isSome(item.children);
	const menuIsOpen = hasChildren && routerStore.rootStore.menuStore.menuIsOpen[item.route];
	return (
		<React.Fragment key={item.route}>
			{!hasChildren ? (
				<RouterLink
					routerStore={routerStore}
					routeName={item.route}
					className={'nav__item' + (_.startsWith(routerStore.routerState.routeName, item.route) ? ' active' : '')}
				>
					<i className={item.iconName} data-tip={t(item.title)}>
						<ReactTooltip />
					</i>{' '}
					<span>{t(item.title)}</span>{' '}
					{item.showUnlinkedOrderLines && viewStore.unlinkedOrderLines != 0 && (
						<span>({viewStore.unlinkedOrderLines})</span>
					)}
				</RouterLink>
			) : null}
			{hasChildren ? (
				<section>
					<span className="no_selection">
						<a className="nav__item" onClick={() => routerStore.rootStore.menuStore.toggleMenu(item.route)}>
							<i className={item.iconName} data-tip={t(item.title)}>
								<ReactTooltip />
							</i>{' '}
							<span>{t(item.title)}</span> <i className={menuIsOpen ? item.iconOpen : item.iconClose}></i>
						</a>
						{menuIsOpen ? (
							<div className="nav nav--secondary">
								{item.children.map(subItem => {
									return renderItem(subItem, apiKey, routerStore, t);
								})}
							</div>
						) : null}
					</span>
				</section>
			) : null}
		</React.Fragment>
	);
}

export default defaultTemplate(MenuTemplate);
